<template>
    <v-form class="py-2 px-3">
        <v-header>Services </v-header>
        <v-btn depressed x-small text color="red" @click="selectedServices = []"> <v-icon x-small>{{cancelIcon}}</v-icon>clear all</v-btn>
        <v-container>
            <v-row v-for="service in services" :key="service">
               <v-checkbox
                    :label="service"
                    :value="service"
                    v-model="selectedServices"
                    class="ma-0"
                ></v-checkbox>
            </v-row>
        </v-container>

        <v-header>Stages</v-header>
        <v-btn depressed x-small text color="red" @click="selectedStages = []"> <v-icon x-small>{{cancelIcon}}</v-icon>clear all</v-btn>
        <v-container>
            <v-row v-for="stage in stages" :key="stage">
                <v-checkbox class="ma-0" :label="stage" :value="stage" v-model="selectedStages"></v-checkbox>
            </v-row>
        </v-container>
        <div class="text-center">
            <v-btn @click="$emit('close')">close</v-btn>
        </div>
    </v-form>
</template>

<script>
    import {mdiCloseCircle} from '@mdi/js'
    export default {
        name: "Filter.vue",
        props: ["services", "stages"],
        watch: {
          selectedStages () {
             this.emitFilter()
          },
            selectedServices () {
              this.emitFilter()
          },
        },
        data () {
            return {
                cancelIcon: mdiCloseCircle,
                selectedStages: [],
                selectedServices: [],
            }
        },
        methods: {
            emitFilter() {
                this.$emit('filter', { selectedStages: this.selectedStages, selectedServices: this.selectedServices })
            }
        },
    }
</script>

<style scoped>

</style>
